import type { ComponentType, Ref } from 'react';
import { forwardRef, memo } from 'react';
import Skeleton from '@mui/material/Skeleton';
import type { IconProps } from 'react-feather';
import { MoreHorizontal, MoreVertical } from 'react-feather';
import { cx } from '@trinity/chat-components/utils';
import styles from './style/Anchor.module.css';

export type AnchorProps = {
  className?: string;
  iconClassName?: string;
  Icon: ComponentType<IconProps>;
  open: boolean;
};

type IconlessAnchorProps = Omit<AnchorProps, 'Icon'>;

export const Anchor = memo(
  forwardRef<HTMLDivElement, AnchorProps>((props, ref) => {
    const className = cx(styles.root, props.className, props.open && styles.open);
    const iconClassName = cx(styles.icon, props.iconClassName);
    return (
      <div className={className} ref={ref}>
        <props.Icon className={iconClassName} />
      </div>
    );
  })
);

export const MoreHorizontalAnchor = memo(
  forwardRef<HTMLDivElement, IconlessAnchorProps>((props, ref) => {
    return <Anchor {...props} ref={ref} Icon={MoreHorizontal} />;
  })
);

export const MoreVerticalAnchor = memo(
  forwardRef<HTMLDivElement, IconlessAnchorProps>((props, ref) => {
    return <Anchor {...props} ref={ref} Icon={MoreVertical} />;
  })
);

export const MoreHorizontalAnchorSmall = memo(
  forwardRef<HTMLDivElement, IconlessAnchorProps>((props, ref) => {
    return <MoreHorizontalAnchor {...props} iconClassName={styles.small} ref={ref} />;
  })
);

export const MoreVerticalAnchorSmall = memo(
  forwardRef<HTMLDivElement, IconlessAnchorProps>((props, ref) => {
    return <MoreVerticalAnchor {...props} iconClassName={styles.small} ref={ref} />;
  })
);

type SkeletonProps = {
  className?: string;
};

export const AnchorSkeleton = memo(({ className }: SkeletonProps) => {
  return <Skeleton height={30} width={30} variant="rounded" />;
});
